import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full gap-2" }
const _hoisted_2 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_3 = { class: "text-base leading-[20px]" }
const _hoisted_4 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_5 = { class: "text-base leading-[20px]" }
const _hoisted_6 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_7 = { class: "text-base leading-[20px]" }
const _hoisted_8 = { class: "size-11 rounded-xl bg-[#FAEFE7] border border-gold flex items-center justify-center font-semibold text-xl leading-[24px]" }
const _hoisted_9 = { class: "text-base leading-[20px]" }
const _hoisted_10 = { class: "font-semibold text-2xl text-black" }
const _hoisted_11 = { class: "flex flex-col gap-6 h-full overflow-y-auto bg-white rounded-lg p-4" }
const _hoisted_12 = { class: "flex flex-col gap-4" }
const _hoisted_13 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_14 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_15 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_16 = { class: "flex flex-col gap-4" }
const _hoisted_17 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_18 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_19 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_20 = { class: "flex flex-col gap-4" }
const _hoisted_21 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_22 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_23 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_24 = { class: "flex flex-col gap-4" }
const _hoisted_25 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_26 = { class: "text-left text-base leading-[20px] text-brown" }
const _hoisted_27 = { class: "flex flex-col gap-4" }
const _hoisted_28 = { class: "font-semibold text-2xl text-black text-left" }
const _hoisted_29 = { class: "font-semibold text-xl leading-[24px] text-black text-left" }
const _hoisted_30 = { class: "text-left text-base leading-[20px] text-brown" }

import { ref } from "vue";
import { Pillar } from "@/types/calculators";
import { useI18n } from "vue-i18n";
import ModalComponent from "@/components/ModalComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NatalBirthdayMobile',
  props: {
    pillars: {}
  },
  setup(__props: any) {



const { t } = useI18n();
const hiddenType = ref<"hour" | "day" | "month" | "year" | null>(null);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "bg-[#FDFDFD] rounded-xl flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (hiddenType.value = 'hour'))
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(__props.pillars["hour"].stem), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.hour")), 1)
    ]),
    _createElementVNode("div", {
      class: "bg-[#FDFDFD] rounded-xl flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (hiddenType.value = 'day'))
    }, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.pillars["day"].stem), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.day")), 1)
    ]),
    _createElementVNode("div", {
      class: "bg-[#FDFDFD] rounded-xl flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (hiddenType.value = 'month'))
    }, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(__props.pillars["month"].stem), 1),
      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.month")), 1)
    ]),
    _createElementVNode("div", {
      class: "bg-[#FDFDFD] rounded-xl flex flex-col items-center py-2 gap-4 flex-1",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (hiddenType.value = 'year'))
    }, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(__props.pillars["year"].stem), 1),
      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.times.year")), 1)
    ]),
    _createVNode(ModalComponent, {
      show: hiddenType.value !== null,
      variant: "fullscreen",
      onClose: _cache[4] || (_cache[4] = ($event: any) => (hiddenType.value = null)),
      "container-class": "bg-beige"
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)(`calculators.bazi.modal.natal.title.${hiddenType.value}`)), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(__props.pillars[hiddenType.value].stem) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.heaven-stem")), 1),
            _createElementVNode("h5", _hoisted_14, _toDisplayString(__props.pillars[hiddenType.value].labels.stem), 1),
            _createElementVNode("p", _hoisted_15, _toDisplayString(__props.pillars[hiddenType.value].tips.stem), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, _toDisplayString(__props.pillars[hiddenType.value].branch) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.earth-branch")), 1),
            _createElementVNode("h5", _hoisted_18, _toDisplayString(__props.pillars[hiddenType.value].labels.branch), 1),
            _createElementVNode("p", _hoisted_19, _toDisplayString(__props.pillars[hiddenType.value].tips.stem), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, _toDisplayString(__props.pillars[hiddenType.value].stage) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.stage")), 1),
            _createElementVNode("h5", _hoisted_22, _toDisplayString(__props.pillars[hiddenType.value].labels.stage), 1),
            _createElementVNode("p", _hoisted_23, _toDisplayString(__props.pillars[hiddenType.value].tips.stage), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, _toDisplayString(_unref(t)(
                  `calculators.bazi.modal.natal.element.${__props.pillars[hiddenType.value].element}`
                )), 1),
            _createElementVNode("p", _hoisted_26, _toDisplayString(__props.pillars[hiddenType.value].tips.element), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(__props.pillars[hiddenType.value].god) + " " + _toDisplayString(_unref(t)("calculators.bazi.results.birthday-map.stem.god")), 1),
            _createElementVNode("h5", _hoisted_29, _toDisplayString(__props.pillars[hiddenType.value].labels.god), 1),
            _createElementVNode("p", _hoisted_30, _toDisplayString(__props.pillars[hiddenType.value].tips.god), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})